<template>
  <div :key="key">
    <app-bar :showtab="false">
      <template v-slot:title>用户中心</template>
    </app-bar>
    <v-card
      v-if="
        !$store.state.user.userinfo.server ||
        $store.state.user.userinfo.server == '127.0.0.1:19132' ||
        !$store.state.user.userinfo.email
      "
      color="red"
      dark
    >
      <v-card-title>你还没有完善账户信息</v-card-title>
      <v-card-subtitle
        >你还没有完善账户的信息，上传的功能将变得不可用</v-card-subtitle
      >
    </v-card>
    <v-card class="mt-4">
      <v-list line>
        <v-subheader>个人信息</v-subheader>

        <v-list-item>
          <v-list-item-content>
            <v-list-item-title
              >用户名：{{ $store.state.user.userinfo.name }}</v-list-item-title
            >
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title
              >QQ：{{ $store.state.user.userinfo.qq }}</v-list-item-title
            >
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title
              >电话：{{ $store.state.user.userinfo.area_code }}
              {{ $store.state.user.userinfo.phone }}</v-list-item-title
            >
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
        <v-list-item @click="mailDialog = true">
          <v-list-item-content>
            <v-list-item-title
              >邮箱：<template v-if="!$store.state.user.userinfo.email">
                未绑定邮箱 (点击绑定)
              </template>
              <template v-else
                >{{ $store.state.user.userinfo.email }} (点击修改)</template
              >
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-card>
    <v-card class="mt-4">
      <v-list>
        <v-subheader>更多</v-subheader>
        <v-divider></v-divider>
        <!-- <v-subheader>绑定的服务器</v-subheader> -->
        <v-list-item @click="serverDialog = true">
          <v-list-item-content>
            <v-list-item-title
              >服务器地址:
              {{
                $store.state.user.userinfo.server == "127.0.0.1:19132" ||
                !$store.state.user.userinfo.server
                  ? "未绑定服务器 (点击绑定)"
                  : $store.state.user.userinfo.server
              }}
              </v-list-item-title
            >
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
        <v-list-item @click="openapiDialog = true">
          <v-list-item-content>
            <v-list-item-title>OpenAPI: 点我获取Token</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
        <v-list-item to="/passwd_reset">
          <v-list-item-content>
            <v-list-item-title>密码重置</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-card>

    <v-dialog v-model="mailDialog" max-width="500">
      <v-form ref="mail">
        <v-card :loading="loading" :disabled="loading">
          <v-card-title class="headline">邮箱修改</v-card-title>
          <v-card-text>
            我们需要验证你是否拥有新的邮箱，点击发送验证码，给新的邮箱发送一份验证码

            <v-text-field
              v-model="mail"
              prepend-inner-icon="mdi-email"
              label="新的邮箱"
              required
              :rules="rules.mail"
              color="link"
            ></v-text-field>
            <v-text-field
              v-model="mail_code"
              prepend-inner-icon="mdi-email"
              label="邮箱验证码"
              required
              type="number"
              :rules="rules.code"
              color="link"
            ></v-text-field>
            <Vaptcha
              ref="captcha"
              v-model="vaptcha"
              scene="1"
              style="height: 46px"
              type="click"
            ></Vaptcha>
          </v-card-text>
          <v-card-actions>
            <v-btn
              @click="getMailCode"
              :loading="mail_code_loading"
              class="mt-2"
              text
              color="link"
              dark
              >发送验证码</v-btn
            >

            <v-spacer></v-spacer>
            <v-btn color="success darken-1" text @click="mailDialog = false">
              取消
            </v-btn>
            <v-btn color="error darken-1" text @click="upMail()"> 修改 </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <v-dialog v-model="serverDialog" max-width="500">
      <v-card>
        <v-card-title> 绑定的服务器地址修改 </v-card-title>
        <v-card-subtitle>
          请输入新的服务器地址,以及证明你是腐竹的3张截图
        </v-card-subtitle>
        <v-card-text>
          <v-form ref="imges">
            <v-text-field
              v-model="serverIp"
              label="服务器IP"
              :rules="[(v) => !!v || '不能为空']"
              placeholder="xxxx.xxxx.xxx:xxxx"
              prepend-icon="mdi-server"
              color="link"
            />

            <v-file-input
              v-model="upload[0]"
              :rules="[(v) => !!v || '不能为空']"
              color="link"
              label="控制台输入服务器IP和端口然后截图"
              required
            />
            <v-file-input
              v-model="upload[1]"
              :rules="[(v) => !!v || '不能为空']"
              color="link"
              label="包含一定量的玩家服务器内聊天记录"
              required
            />
            <v-file-input
              v-model="upload[2]"
              :rules="[(v) => !!v || '不能为空']"
              color="link"
              label="游戏内截图"
              required
            />
          </v-form>
          <Vaptcha
            ref="captcha"
            v-model="vaptcha"
            scene="1"
            style="height: 46px"
            type="click"
          ></Vaptcha>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn @click="serverDialog = false" text color="error"> 取消</v-btn>
          <v-btn :loading="loading" @click="server" text color="link">
            修改</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="openapiDialog" max-width="500">
      <v-card>
        <v-card-title> 获取OpenApi Token </v-card-title>
        <v-card-subtitle>
          注意：请妥善保存此Token，如果遗失，请重新获取，并且旧的Token会失效
        </v-card-subtitle>
        <v-card-text>
          <v-textarea
            color="link"
            v-model="aptToken"
            rows="8"
            outlined
            dense
            hide-details
          ></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn @click="openapiDialog = false" text color="error">取消</v-btn>
          <v-btn @click="updateToken" :loading="loading" text color="link"
            >更新Token</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import AppBar from "@/components/common/AppBar/AppBar";
import login from "@/networker/login";
import List from "@/networker/list";
import util from "../../networker/util";
export default {
  name: "User",
  components: {
    AppBar,
  },
  data() {
    return {
      key: 0,
      data: {},
      mail: "",
      mail_code: "",
      mail_code_loading: false,
      error: "",
      pub: false,
      loading: false,
      mailDialog: false,
      serverDialog: false,
      openapiDialog: false,
      aptToken: "",
      serverInfo: {},
      upload: [],
      serverIp: "",
      items: ["NUKKIT", "PocketMine-MP", "BDS", "Other"],
      rules: {
        code: [(v) => !!v || "不能为空"],
        mail: [
          (v) => !!v || "不能为空",
          (v) => /.+@.+\..+/.test(v) || "请输入正确的邮箱",
        ],
        ip: [(v) => !!v || "不能为空"],
        port: [
          (v) => !!v || "不能为空",
          (v) => v <= 65535 || "端口必须小于65535",
          (v) => v > 0 || "端口必须大于0",
        ],
      },
      captcha: {},
      vaptcha: null,
    };
  },
  mounted() {},
  methods: {
    onVerify(e) {
      this.captcha = e;
    },
    async getMailCode() {
      if (!this.mail) {
        this.$emit("snackbar", {
          text: "请输入新的邮箱",
        });
        return;
      }
      if (!this.validate()) {
        this.$emit("snackbar", {
          text: "请先完成验证码",
        });
        return;
      }
      this.mail_code_loading = true;
      let res = await login.validateMail(this.mail, this.captcha, "修改邮箱");

      if (res.data.success) {
        this.$emit("snackbar", {
          text: res.data.message,
        });
      }
      this.mail_code_loading = false;
    },
    async upMail() {
      if (!this.validate()) {
        this.$emit("snackbar", {
          text: "请先完成验证码",
        });
        return;
      }

      this.loading = true;
      let res = await login.mail(this.mail, this.mail_code);
      this.loading = false;
      if (res.data) {
        this.$emit("snackbar", {
          text: res.data.message,
        });
      }
      // 刷新token
      this.asyncUserInfo();
      this.$refs.captcha.vaptcha.reset();
      this.mailDialog = false;
    },
    async server() {
      if (!this.$refs.imges.validate()) {
        return;
      }
      if (!this.validate()) {
        this.$emit("snackbar", {
          text: "请先完成验证码",
        });
        return;
      }

      this.loading = true;
      let res = await login.server(this.serverIp, this.captcha, this.upload);
      this.loading = false;
      if (res.data) {
        this.$emit("snackbar", {
          text: res.data.message,
        });
      }
      this.asyncUserInfo();
      this.$refs.captcha.vaptcha.reset();
      this.serverDialog = false;
    },
    async updateToken() {
      this.loading = true;

      let res = await util.openapiToken();
      console.log(res);
      this.aptToken = res.data.data.token;
      this.loading = false;
    },
    async asyncUserInfo() {
      let res = await login.userInfo();
      if (res.data.status == 2000) {
        this.$emit("login:success", res.data.data);
      }
    },
    validate() {
      let c = this.handle_captcha(null, 1);
      if (c) {
        this.captcha = c.captcha;
        return true;
      }
      return false;
      // return this.$refs.from.validate() && c;
    },
    handle_captcha(obj = null, scene = 0) {
      let api_server;
      let token;
      if (obj === null) {
        if (this.vaptcha == null) {
          return null;
        }
        api_server = this.$refs.captcha.vaptcha.config.api_server;
        token = this.vaptcha.token;
      } else {
        api_server = obj.config.api_server;
        token = obj.token;
      }
      let api_server_array = api_server.split(".");
      if (api_server_array[1] !== "vaptcha") {
        return null;
      }
      return {
        captcha: {
          server:this.$refs.captcha.vaptcha.config.server,
          token: token,
          scene: scene,
        },
      };
    },
  },
};
</script>

<style></style>
